// File: cgp-app-bar-menu-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP App Bar Menu component.
// Other Contributors: Joseph M Diaz

import { Component } from '@angular/core';

import { CgpUserProfileDialogService } from '../../cgp-user-profile-dialog/cgp-user-profile-dialog.service';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { AuthenticationService } from '../../../../app/auth.service';
import { config } from '../../../../config/config';

@Component({
    selector: 'cgp-app-bar-user-menu',
    templateUrl: './cgp-app-bar-user-menu.template.html'
})
export class CgpAppBarUserMenuComponent {
    user;
    userMenuText;
    userMenuItems;
    userGmin;

    constructor(
        private readonly cgpUserProfileDialogService: CgpUserProfileDialogService,
        private readonly authService: AuthenticationService,
        ) {
        this.user = cgpAuthentication.getUserInfo();
        this.authService.getUserProfile().subscribe(userProfile => {
            if (userProfile.length === undefined) {
                const menuItems = this.getUserMenuItems();
                this.userMenuItems = menuItems.filter(x => {
                    if ((userProfile.GARoles.length === 0 || userProfile.BodyRoles.length === 0) && x.action !== 'switchModule') {
                        return x;
                    } else if (userProfile.GARoles.length !== 0 && userProfile.BodyRoles.length !== 0) {
                        return x;
                    }
                });
            }
        });

        if (this.user) {
            this.userMenuText = this.user.givenName;
            this.userGmin = this.user.gmuniqueidentifier || this.user.gmin;
        }
    }

    getUserMenuItems = () => {
        return config.appBarUserMenu.items.map((item: any) => {
            item.showIcon = (item.icon);
            return item;
        });
    }

    getUserText = () => {
        if (this.user) {
            return this.user.givenName;
        }
    }

    onItemClick = (item) => {
        switch (item.action) {
            case 'openProfileDialog':
                this.onShowUserProfileClick();
                break;
            case 'logOut':
                window.location.href = '#/logged-out';
                break;
            case 'switchModule':
                this.authService.switchModule();
                break;
        }
    }

    onShowUserProfileClick = () => {
        this.cgpUserProfileDialogService.showUserProfileDialog({
            title: 'User Profile',
            closeLabel: 'Cancel'
        });
    }
}
